module.exports = __webpack_public_path__ + "7e1bd167e12e6714780fec7ca22fc0ed.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/icomoon.woff
// module id = 409
// module chunks = 0